import {SUINotImplementedError} from "./SUINotImplementedError.js";

export class SUIFeature {

  /**
   * Auto initialize feature
   */
  autoInitAll() {
    throw new SUINotImplementedError();
  }

}
